package com.example.event_management_system.data.repository

import com.example.event_management_system.data.models.User
import com.example.event_management_system.util.currentTimeMillis
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class UserRepository(
    private val firestore: FirebaseFirestore
) : IUserRepository {
    private val usersCollection = firestore.collection("users")

    override suspend fun getUser(userId: String): User? {
        val doc = usersCollection.document(userId).get()
        return if (doc.exists) {
            doc.data<User>().copy(id = doc.id)
        } else {
            null
        }
    }

    override fun getUserFlow(userId: String): Flow<User?> {
        return usersCollection.document(userId).snapshots.map { doc ->
            if (doc.exists) {
                doc.data<User>().copy(id = doc.id)
            } else {
                null
            }
        }
    }

    override suspend fun createUser(user: User): String {
        val currentTime = currentTimeMillis()
        val userWithTimestamp = user.copy(createdAt = currentTime)
        usersCollection.document(user.id).set(userWithTimestamp)
        return user.id
    }

    override suspend fun updateUser(userId: String, user: User) {
        usersCollection.document(userId).set(user)
    }

    override suspend fun updateLastLogin(userId: String) {
        val currentTime = currentTimeMillis()
        usersCollection.document(userId).update("lastLogin" to currentTime.toDouble())
    }

    override suspend fun setPrimaryLocation(userId: String, locationId: String) {
        usersCollection.document(userId).update("primaryLocationId" to locationId)
    }

    override fun getAllUsersFlow(): Flow<List<User>> {
        return usersCollection
            .where { "isActive" equalTo true }
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { doc ->
                    doc.data<User>().copy(id = doc.id)
                }
            }
    }
}
